import { Component, inject } from '@angular/core';
import { MetaDataService } from '../metadata.service';

@Component({
    selector: 'tea-shop-fe-maintenance-mode',
    templateUrl: './maintenance-mode.component.html',
    styleUrl: './maintenance-mode.component.css'
})
export class MaintenanceModeComponent {
  private metaDataService = inject(MetaDataService);


  constructor() { 
    this.metaDataService.updateMetadata({
      title: 'Maintenance Mode',
      image: '/assets/contact/sencha-logo.png',
    });
  }
}
